function cleanAddress(rawAddress: string) {
  return `${
    rawAddress.substring(0, 5) +
    "..." +
    rawAddress.substring(rawAddress.length - 4, rawAddress.length)
  } `;
}

export default cleanAddress;
